import JSPDF from 'jspdf';
import "jspdf-autotable";
import moment from 'moment';
import { font } from '../fonts/Roboto-normal.js'

// создание пдф файла на основе дескриптора и данных
// возможно необходима доработка для полного функционала
// вывод в табличном виде
export default async function PdfTable (ds, data){
    // формат страницы пдф
    const pdf = new JSPDF('l', 'px', 'a4');

    // добавление шрифта
    pdf.addFileToVFS("Roboto.ttf", font);
    pdf.addFont("Roboto.ttf", "Roboto", "normal");
    pdf.setFont("Roboto");
    
    const date = moment().format("YYYY-MM-DD HH-mm");

    const marginLeft = 40;

    const title = ds.descr?.title ? ds.descr.title : "отчёт";
    const headers = [[]];
    const headers_id = [];
    const $data=[];

    // формирование заголовков таблицы
    for (const el of ds.descr.items){
        if (el?.pdf===true){
            headers[0].push(el?.title ? el.title : el.id);
            headers_id.push(el.id);
        }
    }
    

    // формирование данных для таблицы
    for (const el of data){
        const obj =[];
        for (const h of headers_id){
            obj.push(el[h]);
        }
        if (Object.keys(obj).length !== 0){
            $data.push(obj);
        }
        
    }

    let content = {
      startY: 50,
      head: headers,
      body: $data,
      styles: {
      font:'Roboto',
      fontStyle: 'normal',
      },
      headStyles :{fillColor : [7, 131, 118]}
    };

    // добавление заголовка 
    pdf.text(title, marginLeft, 40);
    // добавление таблицы 
    // @ts-ignore
    pdf.autoTable(content);
    
    // сохраняем файл
    await pdf.save(`${title}_${date}.pdf`);
    
  
  };